import {
  APP_REVISION,
  APP_REVISION_QUERY_PARAM,
} from 'dashboard/constants/appRevision';

// Helpers para forzar que el navegador cargue el último bundle desplegado tras
// un login o logout. Sin esto, un usuario que tenía la app abierta antes del
// deploy puede quedarse con HTML/JS cacheado por días.
//
// La estrategia: anexar un query param `?_v=<APP_REVISION>` a la URL de
// destino del redirect. El navegador trata URLs con query distinto como
// recursos diferentes, así que va al servidor en lugar de servir desde cache.

const isBrowser = typeof window !== 'undefined';

// Construye una URL agregando (o reemplazando) el query param de versión.
// Acepta tanto rutas relativas (`/app/accounts/1/dashboard`) como URLs
// absolutas. Si recibe algo que no parsea como URL, devuelve el input.
export const appendRevisionQuery = (target, revision = APP_REVISION) => {
  if (!target || typeof target !== 'string') return target;
  if (!isBrowser) return target;

  try {
    const base = window.location.origin;
    const url = new URL(target, base);
    url.searchParams.set(APP_REVISION_QUERY_PARAM, revision);

    // Si el input era relativo, devolver el formato relativo para no cambiar
    // semántica (path + search + hash) salvo que ya viniera absoluto.
    if (target.startsWith('http://') || target.startsWith('https://')) {
      return url.toString();
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch (e) {
    return target;
  }
};
